import type { ComponentProps } from "react"
import cn from "@/v2-ui/utils/utils.cn"

export type BulkFormTableProps = ComponentProps<"div">

function BulkFormTable(props: BulkFormTableProps) {
  const { className, children, ...divProps } = props

  return (
    <div className={cn("bulk-form-table-wrapper", className)} {...divProps}>
      <table className="bulk-form-table">{children}</table>
    </div>
  )
}

export default BulkFormTable
